export default "\n<div class=\"copyright\">\n  © ASAP - Performance do conhecimento.\n</div>\n"